export interface TempDataState {
	isUnauthorizedUser?: boolean;
}

export const tempDataActions = {
	saveTempData: '@tempData/saveTempData',
};
